<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_sport.jpeg')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          スポーツベット利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2025年9月8日
        </h2>
        <ol class="terms-list">
          <li class="fs_5">
            はじめに
            <ul class="list-type-disc">
              これらのスポーツブック利用規約（以下、『利用規約』）は、勝Win（以下、『弊社』）が提供するスポーツベットのサービス（以下、『スポーツブック』）の利用に関する条件を定めるものとです。スポーツブックでベットを賭けることにより、お客様はさい利用規約を読み、理解し、同意したものとみなされます。
            </ul>
          </li>
          <li class="fs_5">
            ベットの成立・同意および取消し
            <ul class="list-type-disc">
              <li>
                ベットは、弊社のシステムにより正式に受領され、ベット履歴に反映された時点で成立したものとみなされます。
              </li>
              <li>
                お客様は、ベットを確定・送信することにより、本スポーツベッティング利用規約および弊社の一般利用規約に同意したものとみなされます。
              </li>
              <li>
                ベット確定前に、お客様は選択内容、オッズ、ベット額、ならびにマーケット条件を十分に確認する責任を負います。
              </li>
              <li>
                ベット成立後のキャンセルまたは内容変更は、原則として認められません。
              </li>
              <li>
                イベント開始後、または結果が既に判明していると弊社が判断する場合に行われたベットは、ライブベッティング対象でない限り無効とされる場合があります。
              </li>
              <li>
                弊社は、事前の通知なく、独自の裁量によりいかなるベットも拒否する権利を有します。
              </li>
              <li>
                明白なオッズの誤表示、不正アクセス、システム障害などの特別な事情が認められる場合、弊社は該当ベットを無効とすることができます。
              </li>
              <li>
                イベントが中断された場合、公式データに基づき、賭け伝票に記載されたマーケットが開始時間から12〜48時間以内に完了しなかった場合は、次のように取り扱われます。中断時点ですでに結果が確定している賭けについては、その時点の結果を基に精算されます。一方で、結果が確定していない賭けについてはすべて無効となり、賭け金は返金されます。なお、特定のスポーツにおいて別途ルールが定められている場合は、そのスポーツのルールが優先されます。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            ベットの受付時間
            <ul class="list-type-disc">
              <li>
                弊社は、各マーケットにおけるベットの受付を、イベント開始前または試合中に行います。受付可否および締切は、弊社システムの時間設定に基づき自動的に管理されます。
              </li>
              <li>
                プレマッチベットは、イベント開始予定時刻の直前までに行う必要があります。
              </li>
              <li>
                イベント開始後に行われたプレマッチベットは、原則として無効とされます。
              </li>
              <li>
                システム上の遅延や表示エラーにより、開始後でもベット可能な状態となっていた場合でも、弊社は該当ベットを無効にする権利を有します。
              </li>
              <li>
                ライブベットは、試合中に弊社が定めた時間・状況でのみ提供されます。
              </li>
              <li>
                得点、ペナルティ、交代などの重要な試合状況に応じて、オッズの一時停止（オッズ凍結）が行われる場合があります。
              </li>
              <li>
                凍結中に行われたベットは、弊社の判断により受付が拒否されるか、無効とされる場合があります。
              </li>
              <li>
                ベット受付時刻は、弊社サーバー上に記録されたタイムスタンプが正式なものとされます。
              </li>
              <li>
                お客様側の端末、ブラウザ、ネットワーク環境などによる遅延や誤差は考慮されません。
              </li>
              <li>
                ベットが正常に受付された場合は、当該ベット内容と受付時刻が「ベット履歴」画面に表示されます。
              </li>
              <li>
                表示されていない場合は、ベットが成立していないか、無効とされる可能性があります。
              </li>
              <li>
                弊社は、ベット受付に関するシステム障害や技術的エラーにより発生したいかなる損害についても責任を負いません。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            イベント日時、オッズ、結果および関連情報の取扱い
            <ul class="list-type-disc">
              <li>
                <span class="fw_bold">イベント日時および開始時間</span>
                <ul class="list-type-circle">
                  <li>
                    弊社が提供するすべてのスポーツベットイベントの日時・開始時間は、公式競技団体の発表、試合主催者、または弊社が信頼する第三者情報提供機関の情報に基づき表示されます。
                  </li>
                  <li>
                    イベントの日時・開始時間は予告なく変更されることがあり、その場合は弊社が適宜情報を更新しますが、お客様は変更に伴う損害や影響について弊社に責任を問えません。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">オッズの確定および変更</span>
                <ul class="list-type-circle">
                  <li>
                    オッズは弊社の裁量により、ベット受付時点で確定します。オッズは事前に公開される場合がありますが、最終的には賭けを受け付けた瞬間のオッズが適用されます。
                  </li>
                  <li>
                    技術的要因やシステムエラー、オッズの誤表記などが判明した場合、弊社は当該ベットの取消、修正、または無効化を行う権利を有します。
                  </li>
                  <li>
                    一部マーケットにおいては、ベット受け付け後でもオッズ変更が行われる場合がありますが、その詳細はマーケット説明に従います。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">試合結果および関連情報の決定</span>
                <ul class="list-type-circle">
                  <li>
                    試合の結果やスコア、統計データ、ペナルティ、延長戦の有無などは、弊社が採用する公式統計データ提供機関（例：Opta、Sportradarなど）またはその他信頼できる情報源のデータに基づき決定されます。
                  </li>
                  <li>
                    公式結果が訂正・変更された場合は、弊社は最新の公式情報を基にベットの結果を修正する場合があります。
                  </li>
                  <li>
                    結果の決定基準が不明確な場合や紛争が発生した場合は、弊社の裁定が最終的かつ決定的なものとします。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">イベントの中止、延期および無効化</span>
                <ul class="list-type-circle">
                  <li>
                    イベントが主催者側の都合や不可抗力により中止または延期された場合、当該イベントに関するベットは弊社が定めるルールに従い処理されます。
                  </li>
                  <li>
                    延期されたイベントは、原則として延期後の開催日で結果が決定されますが、弊社が別途指定する場合を除き、延期期間が一定期間（例：30日）を超えた場合はベットが無効となりベット額は返金されます。
                  </li>
                  <li>
                    不可抗力やルール違反等によりイベントが無効となった場合、該当するベットは無効となり、ベット額は返金されるものとします。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">情報の正確性および責任範囲</span>
                <ul class="list-type-circle">
                  <li>
                    弊社はイベント日時、オッズ、結果および関連情報の正確性の維持に対して最大限努力いたしますが、情報提供の遅延、誤差、誤表記等による損害について一切の責任を負いません。
                  </li>
                  <li>
                    お客様は提供される情報を自己の責任で利用し、弊社の情報に起因する損害に関して、いかなる請求も行わないことに同意します。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="fs_5">
            オッズ
            <ul class="list-type-disc">
              <li>
                表示されているオッズは常に変動しており、ベット確定時のオッズが適用されます。
              </li>
              <li>
                お客様は表示されているオッズの形式を十分理解した上でベットを賭けるものとします。
              </li>
              <li>
                オッズの変動や表記に起因する誤解やトラブルについて、弊社は一切責任を負いません。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            キャッシュアウト
            <ul class="list-type-disc">
              <li>
                弊社は、対象となるマーケットにおいてキャッシュアウト機能を提供する場合があります。
              </li>
              <li>
                キャッシュアウト額はリアルタイムで変動し、提示されている額は保証されません。
              </li>
              <li>
                一度確定されたキャッシュアウトは、いかなる理由でも取消不可とします。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            マルチベット
            <ul class="list-type-disc">
              <li>
                すべての選択肢（セレクション）が的中した場合に限り、マルチベットは成立し、配当が支払われます。
              </li>
              <li>
                1つでも選択肢が不的中となった場合、そのマルチベットは失効となります。
              </li>
              <li>
                オッズは各選択肢の単独オッズを掛け合わせた合算オッズで計算されます。
              </li>
              <li>
                マルチベット内のすべての選択肢は、弊社が提供する合法的なマーケットからのものである必要があります。
              </li>
              <li>
                ベット受付締切時間は、マルチベット内の最後に締切となる個別ベットの受付時間に準じます。
              </li>
              <li>
                マルチベットに含まれる個別ベットの結果確定に遅延や変更が生じた場合、弊社は状況に応じて該当マルチベットの処理方法を決定します。
              </li>
              <li>
                特定のプロモーションやキャンペーンによっては、マルチベットに対する追加条件や制限が適用される場合があります。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            スポーツ毎のベットルール
            <ul class="list-type-disc">
              <li>
                <span class="fw_bold">サッカー</span>
                <ol class="list-inside pb_5">
                  1.1サッカーに対するベットは、特に明記されていない限り、前後半90分間（アディショナルタイム含む）終了時点の公式結果に基づいて精算されます。延長戦およびPK戦の結果は対象外となります。
                  <br>
                  <br>
                  1.2 会場が変更された場合でも、ホーム・アウェイのチームが変わらない限り、すべてのベットは有効です。ホーム/アウェイが逆転した場合は、すべてのベットが無効となります。
                  <br>
                  <br>
                  1.3 試合形式（試合時間の短縮、選手数の変更等）やルールがFIFAの規定と異なる場合、弊社は裁量によりベットを無効にする、または新しい条件に基づいて精算する権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">野球</span>
                <ol class="list-inside pb_5">
                  1.1 野球に関するベットは、特に明記されていない限り、規定イニング終了時点（通常9回、延長がない場合は規定回の終了）の公式結果に基づいて精算されます。プロ野球の公式スコアに準拠します。
                  <br>
                  <br>
                  1.2 会場や対戦カードの変更が生じても、試合形式（例：5回制など特殊試合を除く）および対戦チームが同じであればベットは有効です。
                  <br>
                  <br>
                  1.3 試合形式（例：7回戦、マッスルカー規定の短縮試合等）が標準と異なる場合、マーケットへの明記がなければ弊社はベットを無効または裁量精算する権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">バスケットボール</span>
                <ol class="list-inside pb_5">
                  1.1 すべてのベットは、試合終了時点（規定の試合時間 + 延長戦を含む）の公式結果に基づいて精算されます。延長戦で決着がついた場合でも、マネーライン、ハンディキャップ、トータルポイント等のマーケットは延長を含んだ最終スコアを用いて精算されます。
                  <br>
                  <br>
                  1.2 会場が変更された場合、ホームチームとアウェイチームの公式指定が維持されていれば、すべてのベットは有効とされます。役割が反転した場合、該当する試合に関連するベットは無効となります。
                  <br>
                  <br>
                  1.3 非公式試合（エキシビション、チャリティーマッチ、短縮試合等）は、事前にマーケットにその旨が明記されていない限り、弊社はベットを無効とする権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">バスケットボール（3×3）</span>
                <ol class="list-inside pb_5">
                  1.1 3x3バスケットボールに対するベットは、特に明記されていない限り、規定の試合時間（10分間）または21点先取の時点での公式結果に基づいて精算されます。延長戦（オーバータイム）が実施された場合、その得点も含まれます。
                  <br>
                  <br>
                  1.2 会場が変更された場合でも、チーム構成および試合形式（3対3）に変更がない限り、すべてのベットは有効です。会場条件により競技形式が異なると判断された場合、ベットは無効とされることがあります。
                  <br>
                  <br>
                  1.3 試合形式（得点制限の解除、延長ルールの変更等）や出場人数がFIBA 3x3の公式ルールと異なる場合、弊社は裁量によりベットを無効にする、または新しい条件に基づいて精算する権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">テニス</span>
                <ol class="list-inside pb_5">
                  1.1 テニスに対するベットは、特に明記されていない限り、試合の最終結果（試合の勝敗）に基づいて精算されます。ATP、WTA、ITF、グランドスラムなどの公式結果が基準となります。
                  <br>
                  <br>
                  1.2 会場やコートサーフェス（例：クレーからハード）などの変更があった場合でも、対戦カードが同一であればベットは有効です。ただし、別大会または非公式イベントへの代替が行われた場合は無効となります。
                  <br>
                  <br>
                  1.3 試合形式（ベスト・オブ・3セットまたは5セット）に関して、マーケット名に明示されていない限り、どちらの形式でもベットは有効とされます。試合がスーパータイブレーク方式で代替される場合も同様です。弊社は必要に応じてベットを無効にする権利を有します。
                </ol>
              </li>
            </ul>
          </li>
          <li class="fs_5">
            最大払い戻し額
            <ul class="list-type-disc">
              <li>
                弊社が提供するスポーツベットにおける1ベットあたりの最大払い戻し額は、マーケットの種類、スポーツ種目、オッズの種類、またはイベントの重要性に応じて弊社が定める上限に制限されます。
              </li>
              <li>
                同一お客様（またはグループを含む）が同一内容のベットを複数回に分けて行った場合、該当するベットを1つのベットとみなすことができるものとし、その場合の払い戻しの上限も合算ベースで適用されます。
              </li>
              <li>
                弊社は必要に応じて最大払い戻し額の上限を変更、制限、または特定マーケットに適用される制限を事前の通知なく導入する権利を有します。
              </li>
              <li>
                払い戻し金額の計算において、弊社システムのエラーや不正確なオッズ適用により上限を超える金額が表示された場合でも、実際の払い戻し額は上記制限の範囲内に調整されます。
              </li>
              <li>
                お客様は、上記の最大払い戻し額が自らのベットに適用されることを理解するものとします。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            情報の正確性
            <ul class="list-type-disc">
              <li>
                弊社が提供するスコア、試合状況、統計等は参考情報であり、公式結果とは異なる可能性があります。
              </li>
              <li>
                ベットの最終的な精算は、公式競技運営機関または統括団体の発表に基づいて行われます。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            不正行為およびベッティングの誠実性
            <ul class="list-type-disc">
              <li>
                お客様は、すべてのベットを誠実かつ正当な意図に基づいて行うものとし、スポーツイベントの操作、八百長、不正確な情報に基づく賭け、または内部情報の不正利用を含むあらゆる不正行為に関与してはなりません。
              </li>
              <li>
                弊社は、以下のいずれかに該当するベットについて、受付の拒否、無効化、または一方的なキャンセルを行う権利を有します：
                <ul class="list-type-circle">
                  <li>
                    試合の結果が操作された、またはその可能性が高いと判断される場合
                  </li>
                  <li>
                    お客様がチーム、選手、審判、または関係者と不適切な関係にあると判明した場合
                  </li>
                  <li>
                    同一イベントに対して、明らかに統制されたグループによる大量かつ同一傾向のベットが確認された場合
                  </li>
                  <li>
                    ベットが、規制当局、スポーツ統括団体、または不正監視機関（例：Sportradar）からの警告対象となった場合
                  </li>
                </ul>
              </li>
              <li>
                弊社は、必要に応じて該当ユーザーのベット履歴およびアカウントを調査し、適切な措置（アカウント凍結、関係当局への通報等）を講じることができます。弊社は、不正行為の疑いにより発生したいかなる損害や逸失利益についても責任を負いません。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            一般規約の適用
            <ul class="list-type-disc">
              <li>
                本スポーツベット利用規約は、弊社が別途定める一般利用規約とあわせて適用されます。
              </li>
              <li>
                特に明記されていない限り、以下の項目に関する規定は、一般利用規約の内容がそのまま本規約にも適用されるものとします：
                <ul class="list-type-circle">
                  <li>
                    アカウントおよび個人情報の取扱い
                  </li>
                  <li>
                    準拠法および裁判管轄
                  </li>
                  <li>
                    規約の改定・変更手続き
                  </li>
                  <li>
                    通知方法および言語
                  </li>
                  <li>
                    責任の制限および免責事項
                  </li>
                  <li>
                    知的財産権およびコンテンツの使用条件
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      content: false
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
